module.exports = __webpack_public_path__ + "img/xxx.bed2ec8b.png";